import axios, { type AxiosResponse } from 'axios'
import { msal, state } from "@/services/msal-config";
import { type AccountInfo, InteractionRequiredAuthError, type SilentRequest } from "@azure/msal-browser";
import { showNotification, NotificationLevel } from "@/services/notification-center";


const apiClient = axios.create({
  baseURL: import.meta.env.VITE_BAGEND_URI
})

export const invokeGet = async (entityName: string, url: string, config: any = {}): Promise<void | AxiosResponse> => {
    return await invoke(
        'GET',
        entityName,
        url,
        config,
        (url, config) => apiClient.get(url, config))
}

export const invokePost = async (entityName: string, url: string, data: any, config: any = {}): Promise<AxiosResponse> => {

    return await invoke(
        'POST',
        entityName,
        url,
        config,
        (url, config, data) => apiClient.post(url, data, config),
        data) as AxiosResponse
}

export const invokePut  = async (entityName: string, url: string, data: any, config: any = {}): Promise<AxiosResponse> => {

    return await invoke(
        'PUT',
        entityName,
        url,
        config,
        (url, config, data) => apiClient.put(url, data, config),
        data) as AxiosResponse
}

export const invokeDelete  = async (entityName: string, url: string, config: any = {}): Promise<AxiosResponse> => {

    return await invoke(
        'DELETE',
        entityName,
        url,
        config,
        (url, config) => apiClient.delete(url, config)) as AxiosResponse
}

export const invokePatch = async (entityName: string, url: string, data: any, config: any): Promise<{ response: void | AxiosResponse, reqError: any}> => {

  console.log(`Invoking POST on ${entityName} with URL: ${url}`)
  config.headers = {
    'authorization': `Bearer ${state.user?.idToken}`
  }
  let reqError
  const response = await apiClient.patch(url, data, config)
    .catch((error) => {
      console.error(`Error invoking POST on ${entityName} with URL: ${url}`, error)
      reqError = error
    })
  return { response, reqError }
}

const invoke = async (type: string,
                      entityName: string,
                      url: string,
                      config: any,
                      invocation: (url: string, config: object, data?: object) => Promise<AxiosResponse>,
                      data?: object): Promise<void | AxiosResponse> => {
    console.log(`Invoking ${type} on ${entityName} with URL: ${url}`)


    //// TODO: extract somewhere
    // const tokenScopes = ['user.read', 'openid', '499b84ac-1321-427f-aa17-267ca6975798/.default']
    const tokenScopes = ['499b84ac-1321-427f-aa17-267ca6975798/.default']
    const silentRequest: SilentRequest = {
        scopes: tokenScopes,
        account: state.user as AccountInfo,
        forceRefresh: false
    }

    const interactiveRequest = {
        scopes: tokenScopes,
        loginHint: state.user?.username
    }

    const tokenResponse = msal.acquireTokenSilent(silentRequest).catch(error => {
        if (error instanceof InteractionRequiredAuthError) {
            // fallback to interaction when silent call fails
            return msal.acquireTokenRedirect(interactiveRequest)
        }
    })

    const token = await tokenResponse

    config.headers = {
        'authorization': `Bearer ${token?.idToken}`,
        'acc-tk': token?.accessToken,
    }
    //// TODO: extract end

    return await invocation(url, config, data)
        .catch(error => {
            let errorMessage;
            if (error.message) {
                errorMessage = `[Status code: ${error.response.status}] - ${error.response.data.error}`
            } else if (error.request) {
                errorMessage = `[No response was received] - ${error.message}`
            } else {
                errorMessage = `[Failed to send request] - ${error.message}`
            }

            showNotification(entityName, errorMessage, NotificationLevel.ERROR);
        })
}
